import React, { PureComponent } from 'react';
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class TarjetaFooter extends PureComponent {
    constructor(props) {
        super(props)
    }


    render() {
        const { data, montoTotales } = this.props;
        let component = null;
        let montoPesos = 0;
        let montoUss = 0;
        let largoMonto = montoTotales.length;

        //data.map((item, index) => {
        //    //montoPesos += (item.MonedaOrigenId == 1 ? item.DebitoCredito > 0 ? - item.ImporteCuota : item.ImporteCuotaa : 0);

        //    if (item.MonedaOrigenId == 1) {
        //         //montoPesos += (item.DebitoCredito > 0 ? item.ImporteCuota : montoPesos - item.ImporteCuota)

        //        if (item.DebitoCredito > 0) {
        //            montoPesos -= item.ImporteCuota;
        //        } else {
        //            montoPesos += item.ImporteCuota;
        //        }
        //    }

        //    if (item.MonedaOrigenId == 2) {
        //        montoUss += (item.DebitoCredito > 0 ? item.ImporteCuota : montoUss - item.ImporteCuota )
        //    }
        //   // montoUss += (item.MonedaOrigenId == 2 ? item.DebitoCredito > 0 ?  - item.ImporteCuota : item.ImporteCuotaa : 0);
        //});
        if (largoMonto > 0) {
            if (largoMonto == 1) {
                if (montoTotales[0].MonedaOrigenId == 1) {
                    montoPesos = montoTotales[0].Importe;
                } else {
                    montoUss = montoTotales[0].Importe;
                }
            } else {
                montoTotales.forEach((item) => {
                    if (item.MonedaOrigenId == 1) {
                        montoPesos = item.Importe;
                    }
                    else {
                        montoUss = item.Importe;
                    }
                });
            }
        }

        return (
            <div className="row no-margin box footer">
                <div className="col-xs-3 text-left"></div>
                <div className="col-xs-5 text-left">
                    <label className="label-secondary">Total Tarjeta</label>
                </div>
                <div className="col-xs-2 text-right">
                    <MontoMask monto={montoPesos.toFixed(2)} moneda="" class="label-secondary" />
                </div>
                <div className="col-xs-2 text-right">
                    <MontoMask monto={montoUss.toFixed(2)} moneda="" class="label-secondary" />
                </div>
            </div>
        );

    }
}

export default TarjetaFooter;